import { API } from './API'

export const STATISTICS_PATH = '/admin/statistics'

const queryNames = {
  GET_KPI: 'kpi',
  GET_ORGANIZATIONS_AND_USERS: 'organizations-with-users',
}

const getKpi = async (): Promise<any> => {
  return await API.get(`${STATISTICS_PATH}/kpi`)
}

const getOrgsWithUsers = async (withEmail: boolean): Promise<any> => {
  return await API.get(`${STATISTICS_PATH}/organizations-with-users`, {
    queryStringParameters: {
      includeEmail: withEmail ? 'true' : 'false',
    },
  })
}

export const StatisticsAPI = {
  queryNames,
  getKpi,
  getOrgsWithUsers,
}
